export const setRbSourceFromUTM = () => {
	if (typeof window === 'undefined') return;

	const params = new URLSearchParams(window.location.search);
	const rb = params.get('rb');
	const source = params.get('utm_source');
	const medium = params.get('utm_medium');

	// Store all UTM parameters for internal navigation
	const utmParams = {};
	params.forEach((value, key) => {
		if (key.startsWith('utm_') || key === 'rb') {
			utmParams[key] = value;
		}
	});

	if (Object.keys(utmParams).length > 0) {
		sessionStorage.setItem('utm_params', JSON.stringify(utmParams));
	}

	if (rb) {
		sessionStorage.setItem('rb_source', rb);
	} else if (source === 'facebook') {
		let rbSource = '';

		if (medium === 'ad') {
			rbSource = 'FACEBOOKPAID';
		} else if (medium === 'organic' || medium === 'referral') {
			rbSource = 'FACEBOOKORGANIC';
		}

		if (rbSource) {
			sessionStorage.setItem('rb_source', rbSource);
		}
	} else {
		// Default to "CareerSite" if no Facebook parameters
		const existingRbSource = sessionStorage.getItem('rb_source');
		if (!existingRbSource) {
			sessionStorage.setItem('rb_source', 'CareerSite');
		}
	}
};

export const getRbTrackedLink = (baseLink) => {
	if (typeof window === 'undefined') return baseLink;

	const rbSource = sessionStorage.getItem('rb_source');
	if (!rbSource) return baseLink;

	try {
		const url = new URL(baseLink);
		url.searchParams.set('rb', rbSource);
		return url.toString();
	} catch (e) {
		console.error('Invalid URL in getRbTrackedLink:', baseLink);
		return baseLink;
	}
};

export const getUpdatedRbInternalLink = (href) => {
	if (typeof window === 'undefined') return href;

	try {
		const url = new URL(href, window.location.origin);

		// Add stored UTM parameters
		const storedUtmParams = sessionStorage.getItem('utm_params');
		if (storedUtmParams) {
			const utmParams = JSON.parse(storedUtmParams);
			Object.entries(utmParams).forEach(([key, value]) => {
				url.searchParams.set(key, value);
			});
		}

		// Add current rb_source
		const rbSource = sessionStorage.getItem('rb_source');
		if (rbSource) {
			url.searchParams.set('rb', rbSource);
		}

		return url.toString().replace(window.location.origin, '');
	} catch (e) {
		console.error('Invalid URL in getUpdatedRbInternalLink:', href);
		return href;
	}
};

// Helper function to check if a URL is internal to the current domain
export const isInternalLink = (href) => {
	if (typeof window === 'undefined') return false;

	try {
		const url = new URL(href, window.location.origin);
		return url.hostname === window.location.hostname;
	} catch (e) {
		// If relative URL, it's internal
		return !href.startsWith('http://') && !href.startsWith('https://') && !href.startsWith('mailto:') && !href.startsWith('tel:');
	}
};

// Enhanced link tracking function for all links (internal and external)
export const getTrackedLink = (href) => {
	if (typeof window === 'undefined') return href;

	if (isInternalLink(href)) {
		return getUpdatedRbInternalLink(href);
	} else {
		// For external links (like apply now buttons), use the original getRbTrackedLink
		return getRbTrackedLink(href);
	}
};